module.exports = __webpack_public_path__ + "static/media/music-and-copyright.8218b9cd.jpg";